import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../util/theme';

// import Grid component
import { Grid } from '../../styled';

const BannerContainer = styled(Grid)`
  margin: 0 auto 150px auto;
  padding: 75px 0 0 0;

  @media (min-width: ${getBreakpoint('md')}) {
    margin: 0 auto 50px auto;
  }

  @media (min-width: ${getBreakpoint('lg')}) {
    margin: 0 auto 0 auto;
    padding: 100px 0 0 0;
  }

  @media (min-width: ${getBreakpoint('xl')}) {
    border-bottom: 10px solid ${getColor('primaryBlue')};

    margin: 0 auto 150px auto;
  }
`;

export default BannerContainer;
